<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders to Reopen"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Reopen cancelled work orders."
      @on-submit="createReopenWorkOrdersImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders to Reopen Template.xlsx"
              :file-provider="$importsAPI.getReopenWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CloseWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'reopen-work-orders-imports-add-modal',
    };
  },
  methods: {
    createReopenWorkOrdersImport(data, handleCreate) {
      handleCreate(this.$importsAPI.reopenWorkOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
